export const subscribeToBackgroundNotifications = () => {};
